import React from "react";

export default function CommentPostIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.196 25.242C3 23.4855 3 22.1565 3 16.5C3 10.8435 3 8.0145 5.196 6.258C7.395 4.5 10.929 4.5 18 4.5C25.071 4.5 28.6065 4.5 30.8025 6.258C32.9985 8.016 33 10.8435 33 16.5C33 22.1565 33 23.4855 30.8025 25.242C28.608 27 25.071 27 18 27C14.235 27 12.3 29.607 9 31.5V26.682C7.359 26.4375 6.1515 26.007 5.196 25.242Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
